import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Modal } from "../../../components/ui/Modal";
import { Button } from "../../../components/ui/Button";
import { FormField, Select } from "../../../components/ui/Input";
import api from "../../../services/api";
import { ROLES, extractErrorMessage } from "../utils";

export function ChangeRoleModal({ open, user, onClose, onUpdated }) {
  const { t } = useTranslation();
  const [role, setRole] = useState(user?.role || "VIEWER");
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (open) {
      setRole(user?.role || "VIEWER");
      setError(null);
    }
  }, [open, user]);

  function handleClose() {
    setSaving(false);
    setError(null);
    onClose?.();
  }

  async function handleSubmit() {
    setSaving(true);
    setError(null);
    try {
      await api.put(`/users/${user._id}/role`, { role });
      onUpdated?.(user._id, role);
      handleClose();
    } catch (e) {
      setError(extractErrorMessage(e, t("users.change_role_error_generic")));
    } finally {
      setSaving(false);
    }
  }

  return (
    <Modal
      open={open}
      onClose={handleClose}
      title={t("users.change_role_modal_title")}
      size="sm"
      footer={
        <>
          <Button variant="secondary" onClick={handleClose}>
            {t("common.close")}
          </Button>
          <Button onClick={handleSubmit} loading={saving}>
            {t("common.save")}
          </Button>
        </>
      }
    >
      <p className="text-[12.5px] text-slate-500">
        {t("users.change_role_modal_subtitle", {
          name: `${user?.firstName || ""} ${user?.lastName || ""}`.trim(),
        })}
      </p>
      <FormField label={t("users.field_role")}>
        <Select value={role} onChange={(e) => setRole(e.target.value)}>
          {ROLES.map((r) => (
            <option key={r} value={r}>
              {t(`users.role_${r.toLowerCase()}`)}
            </option>
          ))}
        </Select>
      </FormField>
      {error && <p className="text-[12px] text-rose-600">{error}</p>}
    </Modal>
  );
}

export default ChangeRoleModal;
